<template>
  <div>
    <app-loading v-bind:loading="loading"></app-loading>
    <app-navigation v-bind:activeHome="activeHome"></app-navigation>
    <div class="compatible-homes-list" v-if="selector && selector === 'lot'">
      <div>
        <app-compatible-home-list v-on:homesLoaded="loading = false" v-on:setActiveHome="activeHome = $event"></app-compatible-home-list>
      </div>
    </div>

    <div class="home-list" v-if="selector && selector === 'home'">
        <div>
          <app-home-list v-on:homesLoaded="loading = false"></app-home-list>
        </div>
    </div>
  </div>
</template>

<script>
import CompatibleHomeList from "@/components/journey/home/CompatibleHomeList";
import Navigation from "@/components/journey/nav/Navigation";
import Loading from "@/components/journey/Loading";
import HomeList from "@/components/journey/home/HomeList";

export default {
  name: 'app-community-homes',
  mixins: [],
  components: {
    'app-compatible-home-list': CompatibleHomeList,
    'app-home-list': HomeList,
    'app-navigation': Navigation,
    'app-loading': Loading
  },
  data() {
    return {
      activeHome: null,
      loading: true,
      next: false,
      selector: null
    }
  },
  watch: {
    activeHome: function (val, oldVal) {
      if (val && !oldVal) {

      }
    }
  },
  created() {
    this.getIds();
  },
  methods: {
    getIds: function () {
      const query = this.$route.query;
      if (query.lotid && query.lotcpid) {
        return this.selector = 'lot'
      }
      return this.selector = 'home'
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/home/Home.vue